export default __webpack_public_path__ + "static/photoshop-box-dbe04f28362abf5d506f4b0d33746d3a.png";